import React, { Component } from 'react';
import ErrorApi from "../../api/ErrorApi";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        console.log(error)
        // you can send error to the server
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        try {
            ErrorApi.send({
                boundaryInfo: this.props.boundaryInfo ?? '',
                error,
                errorInfo,
                url: window.location.href ?? '',
                js_cookie: document && document.cookie ? document.cookie : '',
                user_agent: window.navigator ? window.navigator.userAgent : '',
                platform: window.navigator ? window.navigator.platform : ''
            });
        } catch (e) {
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            // return <p>Something went wrong.</p>;
            return null;
        }

        return this.props.children;
    }
}
